import { CSSProperties } from "react";
import { Options } from "material-table";

export type ColumnDefinition<T> = {
  title: string;
  field?: keyof T;
  defaultSort?: "asc" | "desc";
  headerStyle?: CSSProperties;
  cellStyle?: CSSProperties;
  customSort?: (data1: T, data2: T, type: "row" | "group") => number;
  render?: (data: T, type: "row" | "group") => any;
  sorting?: boolean;
  editable?: "always" | "onUpdate" | "onAdd" | "never";
  filtering?: boolean;
};

export class Column<T> {
  title: string;
  field?: keyof T;
  defaultSort?: "asc" | "desc";
  headerStyle?: CSSProperties;
  cellStyle?: CSSProperties;
  customSort?: (data1: T, data2: T, type: "row" | "group") => number;
  render?: (data: T, type: "row" | "group") => any;
  sorting?: boolean;
  editable?: "always" | "onUpdate" | "onAdd" | "never";
  filtering?: boolean;

  constructor(column: ColumnDefinition<T>) {
    this.title = column.title;
    this.field = column.field;
    this.defaultSort = column.defaultSort;
    this.headerStyle = {
      whiteSpace: "nowrap",
      paddingLeft: 0,
      paddingRight: "10px",
      ...column.headerStyle
    };
    this.cellStyle = {
      whiteSpace: "nowrap",
      paddingLeft: 0,
      paddingRight: "10px",
      ...column.cellStyle
    };
    this.customSort = column.customSort;
    this.render = column.render;
    this.sorting = column.sorting;
    this.editable = column.editable;
    this.filtering = column.filtering;
  }
}

export default {
  options: {
    selection: true,
    actionsColumnIndex: -1,
    addRowPosition: "first",
    pageSize: 10,
    pageSizeOptions: [5, 10, 20, 100],
    emptyRowsWhenPaging: false,
    padding: "dense",
    debounceInterval: 300,
    loadingType: undefined
  } as Options
};
